import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import DollarIcon from "../Icons/DollarIcon";
import PdfIcon from "../Icons/PdfIcon";
import EyeIcon from "../Icons/EyeIcon";
import PencilIcon from "../Icons/PencilIcon";
import PadLockIcon from "../Icons/PadLockIcon";
import PadUnlockIcon from "../Icons/PadUnlockIcon";
import IncloudIcon from "../Icons/IncloudIcon";
import Select from "react-select";

const Columns2 = (handleOpenDocument, handleSelectedtypeDocument,options) => [
  {
    dataField: "page",
    text: "Página",
    sort: true,
    style: { width: "5%" },
  },

  {
    dataField: "file",
    text: "Documento",
    sort: true,
    style: { width: "5%" },
    formatter: (cellContent, row) => {
      return (
        <>
          <div
            key={`inboundcolumns_${row?.id}`}
            className="btn-group  mt-md-0"
            size="sm"
            role="group"
          >
            <Button
              style={{ padding: "0.5em" }}
              title="Visualizar documentos"
              onClick={() => handleOpenDocument(row)}
              type="button"
              color="light"
            >
              <EyeIcon width="20px" />
            </Button>
          </div>
        </>
      );
    },
  },
  {
    dataField: "documentPageTypeNumber",
    text: "Tipo Documento",
    sort: true,

    style: { width: "5%" },
    formatter: (cellContent, row) => {
  
      return (
        <Select
        className="form-control resetearControlSelect"
      
        value={options.find(option => option.value == row?.documentPageTypeNumber)}
        placeholder="Seleccione tipo documento"
        onChange={(x) => handleSelectedtypeDocument(x,row)}
        name="documentPageTypeNumber"
        options={options}
      />
       
      );
    },
  },
];

export default Columns2;
